export type RowAction = 'CREATE' | 'UPDATE' | 'LINK' | 'AMBIGUOUS' | 'ERROR' | 'SKIPPED';

export type DashboardStatus =
  | 'pending'
  | 'assigned'
  | 'submitted'
  | 'completed'
  | 'issued'
  | 'cancelled';

export const DASHBOARD_STATUSES: DashboardStatus[] = [
  'pending',
  'assigned',
  'submitted',
  'completed',
  'issued',
  'cancelled',
];

export interface SpreadsheetRef {
  id: string;
  name: string;
}

export interface SheetsSettings {
  spreadsheets: SpreadsheetRef[];
  tab_name_format: string;
  status_map: Record<string, string>;
  updated_at?: string;
}

export type ActionSummary = Partial<Record<RowAction, number>>;

export interface PreviewRow {
  rowNumber: number;
  action: RowAction;
  reason: string;
  docId: string | null;
  currentData?: Record<string, string>;
  proposedChanges?: Record<string, string>;
  candidateDocIds?: string[];
}

export interface PreviewResponse {
  spreadsheetId: string;
  tabName: string;
  rows: PreviewRow[];
  summary: ActionSummary;
}

export interface CommitRowOutcome {
  rowNumber: number;
  action: RowAction;
  docId: string | null;
  success: boolean;
  error?: string;
}

export interface CommitResult {
  spreadsheetId: string;
  tabName: string;
  processed: CommitRowOutcome[];
  successCount: number;
  errorCount: number;
}
